import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  description?: string;
  onBack?: () => void;
  backTo?: string;
  children?: React.ReactNode;
  className?: string;
  variant?: 'default' | 'blue';
}

export function PageHeader({ title, description, onBack, backTo, children, className, variant = 'default' }: PageHeaderProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  const isBlue = variant === 'blue';

  return (
    <div className={`border-b px-6 py-4 ${isBlue ? 'bg-blue-900 border-blue-800' : 'border-border-light bg-card/50 backdrop-blur-sm'} ${className || ''}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button
            variant="outline"
            size="sm"
            onClick={handleBack}
            className={`h-8 w-8 p-0 ${isBlue ? 'border-white/30 bg-white/10 text-white hover:bg-white/20' : ''}`}
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div>
            <h1 className={`text-xl font-semibold ${isBlue ? 'text-white' : 'text-foreground'}`}>{title}</h1>
            {description && (
              <p className={`text-sm mt-1 ${isBlue ? 'text-white/80' : 'text-muted-foreground'}`}>{description}</p>
            )}
          </div>
        </div>
        {children && (
          <div className="flex items-center gap-2">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}